import './Element.matches';

if ( Element && !Element.prototype.closest )
{
	Element.prototype.closest = closest;
}

function closest( selector: string ): Element
{
	let element: Element = this;
	
	while (
		element
		&& ( element.nodeType === Node.ELEMENT_NODE )
	)
	{
		if ( element.matches( selector ) )
		{
			return element;
		}
		
		element = element.parentElement;
	}
	
	return null;
}

declare global
{
	interface Element
	{
		closest: ( selector: string ) => Element;
	}
}
